// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1-AlN","options":"styles_options__ux_PF","title":"styles_title__3yfK3","content":"styles_content__l393D","helpBlock":"styles_helpBlock__1XNEI"};